export const COOKIE_MODAL_ROOT_ID = 'SMHdsCookieConsentContainer';
